import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { mewsEnterprise } from '@mews-commander/utils';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { BusinessError } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { GeneralEnterprise, GeneralPricingMode } from '@mews-commander/data-access';
import { PLATFORM_ADMIN_ENTERPRISE_ID } from '@mews-commander/constants';
import { getEnterprises } from './ducks/enterprises';

export const useLegacyCommanderSelector: TypedUseSelectorHook<ApplicationState> = useSelector;

export const useEnterprise = (enterpriseId: string | null) =>
    useLegacyCommanderSelector<GeneralEnterprise>((state) => {
        if (!enterpriseId || enterpriseId === PLATFORM_ADMIN_ENTERPRISE_ID) {
            return mewsEnterprise;
        }
        const enterprise = getEnterprises(state)[enterpriseId];
        if (enterprise === undefined) {
            throw new BusinessError(`Enterprise with id ${enterpriseId} not found`);
        }
        return enterprise;
    });

export const useCurrentEnterprise = () => {
    const currentEnterpriseId = useCurrentEnterpriseId();
    if (currentEnterpriseId === undefined) {
        throw new BusinessError('Calling useCurrentEnterprise before session init (currentEnterpriseId is undefined)');
    }
    return useEnterprise(currentEnterpriseId);
};

export const useIsMultiTaxEnvironment = () => useCurrentEnterprise().pricing === GeneralPricingMode.Net;
